import { useSelector } from 'react-redux'

// Types
import { State, SignupCodeInfo, SignupState } from 'types'

export const useSignupCode = (): SignupCodeInfo => {
  const state = useSelector<State, SignupState>(s => s.signup)
  const codeInfo = state.signupCodeInfo[state.selectedRefCode]
  return (
    codeInfo || {
      reftext: '',
      reftitle: '',
      refcode: '',
      refcodevalid: false,
      image: '',
      image2: '',
      inviter: '',
      redirect_to: '',
      force_signup_code: false,
    }
  )
}
